<template>
	<section>
		<div class="section-label">
			Quick Tips
		</div>

		<div v-for="quicktip in quicktips" class="d-flex py-2">
			<div class="bg-accent text-center text-white rounded-circle avatar-md mr-2">
				<i class="fad fa-lightbulb-on"></i>
			</div>
			<div v-if="quicktip == 1">
				Tag physicians in your <router-link :to="{ name: 'tasks' }" class="font-weight-bold">tasks</router-link> to mark them for follow ups.
			</div>

			<div v-if="quicktip == 2">
				Contact physicians that have referred a patient in the <router-link :to="{ name: 'smart_lists.new_referrers'}" class="font-weight-bold">last 30 days</router-link>.
			</div>

			<div v-if="quicktip == 3">
				<router-link :to="{ name: 'smart_lists.latent'}" class="font-weight-bold">Latent physicians</router-link> are highly-rated but have not been visited in the 6 months or more.
			</div>
			
			<div v-if="quicktip == 4">
				Use <router-link :to="{ name: 'campaigns.index'}" class="font-weight-bold">campaigns</router-link> to help organize marketing activities beyond physician visits.
			</div>		
			
			<div v-if="quicktip == 5">
				The <router-link :to="{ name: 'smart_lists.radar'}" class="font-weight-bold">RADAR smart list</router-link> identifies new potential referring physicians in your area.
			</div>	
			
			<div v-if="quicktip == 6">
				Find a new physician while on a route? Add a new record with the "Extra Checkins" button.
			</div>	
		</div>
	</section>
</template>

<script>

	export default {
		props: ['quicktips'],
	}

</script>